import { Theme } from '@mui/material'

export const getShadows = (theme: Theme) => {
  const shadows = [...theme.shadows]
  // [1] is the default box-shadow used ([0] is "none") and
  for (let i = 1; i < shadows.length; i++) {
    const yOffset = 4 + i * 0.5 // Start at 4px, add 0.5px per level
    const blur = 8 + i * 2 // Start at 8px, add 2px per level
    const opacity = 0.05 + i * 0.0025 // Start at 0.05, +0.0025 per level (capped sensible)
    shadows[i] = `0px ${yOffset.toFixed(1)}px ${blur.toFixed(1)}px rgba(0, 0, 0, ${Math.min(opacity, 0.16).toFixed(3)})`
  }

  return shadows
}
